module.exports = __webpack_public_path__ + "media/images/medico_gris-859864e6e3b8469195ac082c16e37467.svg";